import { Container} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleCarlineId } from 'src/bff';
import { CarlineWithOffers } from 'src/types';
import { CarlineContext, useFeatureServices, useFaContent, useDisclaimerReference } from 'src/feature-app/hooks';
import { Tabs, AcordionHorizontal, OfferContainer } from 'src/components';
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size';

const getDisclaimers = (carline: CarlineWithOffers): string[] => carline?.ofertas?.map(offer => offer.legal);

export interface ModulProps {
  carlinesWithOffers: CarlineWithOffers;
  themeColor?: string;
}

export const CarouselPage = () => {
  const { 'car-configuration': carConfigurationService } = useFeatureServices();
  const dispatch = useDispatch();
  const [carline, setCarline] = useState<CarlineWithOffers>(null);
  const [loading, setLoading] = useState(true);
  const faContent = useFaContent();
  const width = useWindowWidth();
  const themeColor = faContent?.theme;

  const getOferta = async () => {
    let carlineId: string;

    if (carConfigurationService.get()) {
      carlineId = carConfigurationService.get().carlineId;
    } else {
      // // JUST FOR LOCAL DEVELOPMENT. CMS PROVIDES THE CARLINEID, BUT WE NEED TO PROVIDE IT OURSELVES IN LOCAL.
      carConfigurationService.set({
        carlineId: '30316',
        category: 'commercial',
      });
      carlineId = carConfigurationService.preliminaryConfigurations[0].carlineId;
    }

    const carline = await handleCarlineId(carlineId, faContent);

    if (carline) {
      console.log(carline, 'carline');
      setCarline(carline);
      dispatch({ type: 'UPDATE_CARLINE', payload: carline });
    }
    setLoading(false);
  };

  useEffect(() => {
    getOferta();
  }, []);

  const legales = useDisclaimerReference(getDisclaimers(carline)); // Registro de todos los legales

  return loading ? null : (
    <>
      {carline ? (
        <CarlineContext.Provider value={carline}>
          <Container wrap={"always"}>
            {
              carline.ofertas.length <= 1 ? 
                <OfferContainer
                  carline={carline}
                  setShowOfferToFalse={() => { }}
                  showOffer={true}
                  showCard={false}
                  mode="filter"
                /> : width < 560 ? <Tabs carlinesWithOffers={carline} themeColor={themeColor}/> : <AcordionHorizontal carlinesWithOffers={carline} themeColor={themeColor}/>
            }
          </Container>
        </CarlineContext.Provider>
      ) : null}
    </>
  );
};
